import { useNavigate, useParams } from 'react-router';
import { BookingStepper } from 'booking/components';
import { CompleteStoreFragment, Maybe, useGetStoreQuery } from 'drycut-graphql';
import { useDocumentTitle } from 'usehooks-ts';
import { Loader } from 'ui-components';
import { useStorePubSub } from 'drycut-apollo';
import { useScheduledRefresh } from 'controlled-components';

export function NewBooking(): React.ReactNode {
  useDocumentTitle('DRYCUT - Book');

  const { slug } = useParams() as { slug: string };
  const { data, loading } = useGetStoreQuery({ variables: { slug } });
  const navigate = useNavigate();

  // Refresh the screen at midnight and noon to ensure that the content is always up to date.
  useScheduledRefresh([
    { hour: 20 }, // 8pm, to ensure that the schedule for the next day is always up to date
    { hour: 0 }, // midnight (for new deployments)
  ]);

  const store: Maybe<CompleteStoreFragment> = data?.store || null;

  // Real time updates for the waiting time and stylist list.
  useStorePubSub({ slug });

  if (loading) {
    return <Loader />;
  }

  if (!store || !store.active) {
    navigate('/not-found');
    return null;
  }

  return <BookingStepper store={store} manual />;
}
